import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { ImageUploaderComponent } from 'src/app/image-uploader/image-uploader.component';

@Component({
  selector: 'app-seo-setting',
  standalone: true,
  imports: [CommonModule, FormsModule, ImageUploaderComponent],
  templateUrl: './seo-setting.component.html',
  styleUrls: ['./seo-setting.component.scss']
})
export class SeoSettingComponent implements OnInit {
  public data: any = {};
  public loading = true;

  @ViewChild("ogImageUploader") ogImageUploader: ImageUploaderComponent;

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.loading = true;
    this.data = await this.http.post("/admin/setting/get");

    if (this.data.og_image) {
      this.ogImageUploader.files = [this.data.og_image];
    }
    this.loading = false;
  }

  async submit() {
    if (this.loading) return;

    await this.http.post("/admin/setting/save", this.data);
    this.http.notify("SEO settings updated successfully.");
  }

  upload(data: any, key: string, single = false) {
    this.data[key] = (single) ? data[0] : data;
  }
}
